import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'
import ProjectNameWidget from '../../../../widgets/projectProposal/project/ProjectNameWidget'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../../../utils/loading'
import { getReportSetting, searchReportSetting } from '../../../../redux/actions/reportSetting'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../../utils/widget'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import SearchSubProject from '../../../../widgets/searchSubProject/SearchSubProject'
import ReportSettingWidget from '../../../../widgets/reportSetting/ReportSettingWidget'

export default function ReportSetting() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  const [projectCode, setProjectCode] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    console.log('load ProjectName projectId', projectId)

    handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getReportSetting(proposalId)
      setSchema(_schema)
      // setIsEditWidget({
      //   reportSetting: _schema.forms?.reportSetting?.id ? false : true,
      // })

      // setShowEditAll(!_schema.forms?.reportSetting?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSearchReportSetting = async (mainProjectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await searchReportSetting(mainProjectVersionId)
      setSchema(_schema)
      setProjectCode(mainProjectVersionId)
      setIsEditWidget({
        reportSetting: _schema.forms?.reportSetting?.id ? false : true,
      })

      setShowEditAll(!_schema.forms?.reportSetting?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  const onSubmitSearchSubProject = (data) => {
    console.log('onSubmitSearch', data)

    data.mainProject && handleSearchReportSetting(data.mainProject)
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProjectReport>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {showEditAll && (
            <BtnEditAll
              onClickEditAll={getIsEditAll(isEditWidget)}
              setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            />
          )}

          <SearchSubProject
            schema={schema?.forms?.search}
            onSubmitSearchSubProject={onSubmitSearchSubProject}
          />
          <br />

          {schema?.forms?.reportSetting && (
            <ReportSettingWidget
              showCommandButton={!schema.forms.reportSetting.disabled}
              schema={schema.forms.reportSetting}
              isEdit={isEditWidget.reportSetting}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('reportSetting', _isEdit, setIsEditWidget)
              }
              projectCode={projectCode}
            />
          )}
        </SidebarProposal>
      )}
    </>
  )
}
